import { useQuery } from '@tanstack/react-query';

import { SmsMessage } from '@ndvr/customer-api';

import { CustomerApi } from 'API';

export const TextQueryKeys = {
    TextsQueryKey: (householdGUID: string) => ['Texts', householdGUID] as const,
} as const;

export const useTextsQuery = (householdGUID: string) =>
    useQuery<SmsMessage[]>({
        enabled: !!householdGUID,
        queryKey: TextQueryKeys.TextsQueryKey(householdGUID),
        queryFn: async () => {
            const [response] = await CustomerApi().listSmsMessagesByHousehold(householdGUID);
            return response || [];
        },
        refetchOnMount: false,
        staleTime: Infinity,
    });
